import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinodhavgidc() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Odhav GIDC Ahmedabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Odhav GIDC Ahmedabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Odhav GIDC Ahmedabad, catering to the transportation needs of industrial units, factories, warehouses, and corporate offices in the area. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, supervisors, clients, and senior management. Whether it is daily staff commute, industrial visits, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a dependable and premium corporate travel experience for businesses operating in and around Odhav GIDC Ahmedabad.',

    top: 'Top Places to Visit in Ahmedabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram, located on the banks of the Sabarmati River, was the home of Mahatma Gandhi for over a decade and served as a major center for the Indian freedom movement. Visitors can explore Gandhi’s simple living quarters, archives of letters, photographs, and exhibits explaining India’s struggle for independence. The peaceful environment, museum, and historical displays make it a place of deep reflection and national pride."
  },
  {
    "title": "Sidi Saiyyed Mosque",
    "description": "The Sidi Saiyyed Mosque, built in 1573 during the Gujarat Sultanate period, is renowned for its iconic stone latticework windows known as the 'Sidi Saiyyed Jali'. These intricately carved screens depicting the famous ‘Tree of Life’ are considered masterpieces of Indo-Islamic art. The mosque offers visitors a chance to admire historic craftsmanship and experience one of Ahmedabad’s most recognized architectural symbols."
  },
  {
    "title": "Sabarmati Riverfront",
    "description": "Sabarmati Riverfront is a beautiful riverside development project that has transformed Ahmedabad’s waterfront into a vibrant public space. Featuring pedestrian walkways, gardens, cycling tracks, boating facilities, and event spaces, the riverfront is ideal for family outings, leisure walks, and evening relaxation. The well-maintained urban landscape and scenic views make it a preferred hangout spot for locals and tourists."
  },
  {
    "title": "Adalaj Stepwell",
    "description": "Adalaj Stepwell, located just outside Ahmedabad, is a centuries-old five-story stepwell built in 1498 in Indo-Islamic architectural style. Known for its beautifully carved pillars, ornamental walls, and cooling subterranean design, the stepwell served as a resting place for travelers in earlier times. Today, it stands as an engineering and artistic marvel, offering visitors a glimpse into Gujarat’s architectural heritage."
  },
  {
    "title": "Kankaria Lake",
    "description": "Kankaria Lake is a large man-made lake that has evolved into one of Ahmedabad’s most popular recreational hubs. Surrounding the lake are amusement rides, toy trains, food stalls, a zoo, children’s play zones, and water activities, making it ideal for families. The illuminated musical fountain shows and clean walking paths make evenings at Kankaria lively and memorable."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built in 1424 by Sultan Ahmed Shah, is one of the most impressive mosques in Gujarat. Constructed from yellow sandstone, it features beautifully carved pillars, grand prayer halls, and a harmonious blend of Hindu and Islamic architectural influences. Visitors can explore the expansive courtyard and admire the detailed stonework, reflecting the historical importance of early Ahmedabad."
  },
  {
    "title": "Calico Museum of Textiles",
    "description": "The Calico Museum of Textiles is one of the finest textile museums in the world, preserving centuries of India’s weaving, dyeing, printing, and embroidery traditions. Exhibits include royal costumes, temple cloths, carpets, and antique fabrics displayed in well-curated galleries. Visitors can gain a deep understanding of India's rich textile heritage, craftsmanship, and cultural evolution."
  },
  {
    "title": "Auto World Vintage Car Museum",
    "description": "Auto World Vintage Car Museum houses one of India’s largest collections of classic automobiles, including limousines, sports cars, convertibles, and royal vehicles from Europe and America. Many cars belonged to Indian princely families and are preserved in running condition. The museum offers a nostalgic journey into the history of automotive engineering and luxury travel."
  },
  {
    "title": "Hutheesing Jain Temple",
    "description": "Built in 1848, Hutheesing Jain Temple is a beautifully crafted marble temple dedicated to Lord Dharmanath. The temple features ornate carvings, elaborately decorated domes, and peaceful prayer halls that showcase the artistic traditions of Jain architecture. It is a serene spiritual destination and a remarkable example of Ahmedabad’s religious heritage."
  },
  {
    "title": "Manek Chowk",
    "description": "Manek Chowk is Ahmedabad’s famous city square known for its unique transformation throughout the day: a bustling vegetable market in the morning, a jewelry hub during the day, and a thriving street food destination at night. Visitors can enjoy traditional Gujarati snacks, sweets, and freshly prepared dishes, making it a must-visit spot for food lovers seeking authentic local flavors."
  }
],


"services": [
  {
    "name": "Odhav GIDC Industrial Cab Ahmedabad",
    "description": "Odhav GIDC Industrial Cab Ahmedabad provides specialized transportation for industrial employees. With well-maintained vehicles, trained drivers, and optimized routes, it ensures safe, reliable, and timely daily commuting for staff in Odhav GIDC."
  },
  {
    "name": "Corporate Shuttle Odhav GIDC Ahmedabad",
    "description": "Corporate Shuttle Odhav GIDC Ahmedabad delivers high-capacity shuttle services for companies with large workforces. Featuring AC minibuses, multi-shift support, route optimization, and GPS tracking, it ensures organized and safe staff commuting within Odhav GIDC."
  },
  {
    "name": "Factory Worker Transport Odhav Ahmedabad",
    "description": "Factory Worker Transport Odhav Ahmedabad offers structured transportation for factory employees. With dedicated shuttles, pre-planned schedules, and professional chauffeurs, it guarantees punctual, secure, and efficient daily travel."
  },
  {
    "name": "Office Pickup Drop Odhav GIDC Ahmedabad",
    "description": "Office Pickup Drop Odhav GIDC Ahmedabad provides scheduled pick-up and drop services for corporate employees. The service includes professional drivers, fixed and flexible routes, and GPS-enabled monitoring to ensure safe and punctual daily commutes."
  },
  {
    "name": "Monthly Corporate Cab Odhav Ahmedabad",
    "description": "Monthly Corporate Cab Odhav Ahmedabad offers long-term contract-based transport solutions with dedicated vehicles, trained drivers, route optimization, and GPS tracking, ensuring uninterrupted and cost-effective monthly commuting for companies."
  },
  {
    "name": "Business Cab Odhav GIDC Ahmedabad",
    "description": "Business Cab Odhav GIDC Ahmedabad provides premium corporate travel services for meetings, client visits, airport transfers, and inter-office trips. Featuring sedans and SUVs with professional chauffeurs, it delivers reliable, comfortable, and timely business travel."
  },
  {
    "name": "Affordable Cab Odhav GIDC Ahmedabad",
    "description": "Affordable Cab Odhav GIDC Ahmedabad delivers cost-effective corporate transport solutions without compromising on safety or comfort. Ideal for SMEs and mid-sized companies, it ensures efficient and budget-friendly daily commuting for employees."
  },
  {
    "name": "Best Corporate Cab Odhav GIDC Ahmedabad",
    "description": "Best Corporate Cab Odhav GIDC Ahmedabad offers premium transport services with high-quality vehicles, experienced drivers, and stringent safety standards. Suitable for executives and VIP staff, it ensures a refined, punctual, and professional travel experience."
  },
  {
    "name": "Outstation Cab Odhav GIDC Ahmedabad",
    "description": "Outstation Cab Odhav GIDC Ahmedabad provides long-distance corporate travel solutions for business trips, client visits, and factory tours. Vehicles include comfortable sedans and SUVs, operated by trained chauffeurs with interstate permits and GPS tracking."
  },
  {
    "name": "Sedan Cab Odhav GIDC Ahmedabad",
    "description": "Sedan Cab Odhav GIDC Ahmedabad offers executive sedans suitable for managerial commutes, airport rides, and business travel. Vehicles are well-maintained, equipped with comfort features, and driven by professional drivers to ensure safe and smooth trips."
  },
  {
    "name": "SUV Cab Odhav GIDC Ahmedabad",
    "description": "SUV Cab Odhav GIDC Ahmedabad delivers spacious, premium SUVs ideal for team travel, senior executive transport, and long-distance trips. The service ensures comfort, safety, and reliability with trained chauffeurs and modern vehicles."
  },
  {
    "name": "Employee Shuttle Odhav GIDC Ahmedabad",
    "description": "Employee Shuttle Odhav GIDC Ahmedabad provides structured shuttle services for daily workforce movement. Featuring multi-shift support, route optimization, and real-time tracking, it guarantees organized and efficient employee commuting."
  },
  {
    "name": "Corporate Fleet Odhav Ahmedabad",
    "description": "Corporate Fleet Odhav Ahmedabad offers comprehensive fleet management solutions for companies, including sedans, SUVs, and shuttles. Services cover driver management, vehicle maintenance, compliance, GPS monitoring, and scalable transport support."
  },
  {
    "name": "Staff Transportation Odhav Ahmedabad",
    "description": "Staff Transportation Odhav Ahmedabad delivers reliable daily commute solutions for all employee categories. With trained drivers, optimized routes, and scheduled pick-ups, it ensures safe, timely, and convenient staff mobility."
  },
  {
    "name": "Company Cab Odhav GIDC Ahmedabad",
    "description": "Company Cab Odhav GIDC Ahmedabad provides end-to-end corporate cab services for employees, executives, and visitors. The service includes fleet coordination, maintenance handling, and professional driver management for safe and seamless commuting."
  }
],

"tableData": [
  ["Odhav GIDC Industrial Cab Ahmedabad", "Corporate Shuttle Odhav GIDC Ahmedabad"],
  ["Factory Worker Transport Odhav Ahmedabad", "Office Pickup Drop Odhav GIDC Ahmedabad"],
  ["Monthly Corporate Cab Odhav Ahmedabad", "Business Cab Odhav GIDC Ahmedabad"],
  ["Affordable Cab Odhav GIDC Ahmedabad", "Best Corporate Cab Odhav GIDC Ahmedabad"],
  ["Outstation Cab Odhav GIDC Ahmedabad", "Sedan Cab Odhav GIDC Ahmedabad"],
  ["SUV Cab Odhav GIDC Ahmedabad", "Employee Shuttle Odhav GIDC Ahmedabad"],
  ["Corporate Fleet Odhav Ahmedabad", "Staff Transportation Odhav Ahmedabad"],
  ["Company Cab Odhav GIDC Ahmedabad", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Odhav GIDC Ahmedabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Odhav GIDC Ahmedabad, ensuring smooth and efficient transportation for employees and business executives across the industrial and commercial zones."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We offer punctual pickups and drop-offs across Odhav GIDC and nearby industrial areas, helping employees reach offices, factories, and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Odhav GIDC."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible and tailored corporate cab rental plans to meet the commuting requirements of companies and employees in Odhav GIDC Ahmedabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team is available round-the-clock for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and hygienic rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking system and reliable coordination, making employee transport hassle-free."
  }
]



























  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Odhav GIDC, Ahmedabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and industrial offices in Odhav GIDC, Ahmedabad.',
  },
  {
    question: 'What types of corporate transportation services are available in Odhav GIDC?',
    answer: 'We provide employee transportation, industrial shuttle services, corporate pickups and drops, airport transfers, and full fleet management solutions for corporate and industrial clients.',
  },
  {
    question: 'Do you support daily employee commute services in Odhav GIDC?',
    answer: 'Yes, we offer structured daily commute services with optimized routes, timely pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Odhav GIDC?',
    answer: 'Companies can book via our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Odhav GIDC?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric vehicles depending on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Odhav GIDC?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure maximum safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Odhav GIDC?',
    answer: 'Absolutely. We offer reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehta',
    feedback: 'Dependable corporate cab service for our Odhav GIDC office. Vehicles are clean, and drivers are professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Shah',
    feedback: 'Excellent service for employee commutes. Timely pickups, smooth rides, and courteous drivers make it a great choice.',
    rating: 5,
  },
];












































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Odhav GIDC Ahmedabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-odhav-gidc.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Odhav GIDC Ahmedabad, including industrial cabs, corporate shuttle, factory worker transport, office pickup & drop, monthly corporate cab rentals, business cabs, outstation trips, sedan & SUV corporate cabs, employee shuttle, staff transportation, and complete corporate fleet solutions.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-odhav-gidc-ahmedabad"
  }
};






  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Odhav GIDC Ahmedabad | Industrial & Employee Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services in Odhav GIDC Ahmedabad including industrial cabs, corporate shuttle, factory worker transport, office pickup & drop, monthly corporate cab rentals, business cabs, outstation trips, sedan & SUV corporate cabs, employee shuttle, staff transportation, and complete corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Odhav GIDC Industrial Cab Ahmedabad, Corporate Shuttle Odhav GIDC Ahmedabad, Factory Worker Transport Odhav Ahmedabad, Office Pickup Drop Odhav GIDC Ahmedabad, Monthly Corporate Cab Odhav Ahmedabad, Business Cab Odhav GIDC Ahmedabad, Affordable Cab Odhav GIDC Ahmedabad, Best Corporate Cab Odhav GIDC Ahmedabad, Outstation Cab Odhav GIDC Ahmedabad, Sedan Cab Odhav GIDC Ahmedabad, SUV Cab Odhav GIDC Ahmedabad, Employee Shuttle Odhav GIDC Ahmedabad, Corporate Fleet Odhav Ahmedabad, Staff Transportation Odhav Ahmedabad, Company Cab Odhav GIDC Ahmedabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/116.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinodhavgidc;